<template>
  <div class="container-fluid">
    <div class="row">
      <main id="main" class="site-main main-content">
        <article class="post-30 page type-page status-publish hentry">
          <div class="entry-content">
            <!-- CHOOSE DOMAIN NAME -->
            <div class="slider-moving faq-title">
              <div class="container">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="parent-typed-text wow fadeIn">
                      <span class="mt_typed-beforetext"
                        >Frequently Asked Questions</span
                      >
                      <p style="margin: 20px 0;">Need some help with your order or got a burning question that you need answered pronto? Just click on one of the sections below to find the answer.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>

            <!-- Faq Filter Section Start -->
            <div class="faq-filter">
              <div class="container">
                <div class="row">
                  <!-- Left filter -->
                  <div class="col-md-3 filter" style="margin-bottom: 80px;">
                    <ul>
                      <a
                        v-for="faq in faqList"
                        :key="faq.linkTo"
                        :href="'#' + faq.linkTo"
                        class="faq-butn"
                        ><li>
                          <button>{{ faq.linkTo }}</button>
                        </li></a
                      >
                    </ul>
                  </div>
                  <!-- Right Filter -->
                  <div class="col-md-9">
                    <div
                      class="full-faq"
                      v-for="faq in faqList"
                      :key="faq.name"
                      :id="faq.linkTo"
                    >
                      <div class="row">
                        <div class="col-md-12">
                          <h2>{{ faq.name }}</h2>
                        </div>
                      </div>
                      <div
                        class="row"
                        style="
                          display: inline-block;
                          margin-bottom: 30px;
                          width: 100%;
                        "
                      >
                        <div
                          v-for="(item, index) in faq.qa"
                          :key="item.question"
                          class="col-md-12 ticket-collapse"
                          style="padding: 0 18px;"
                        >
                          <div id="accordion" class="faq-list">
                            <!-- First item -->
                            <div class="card">
                              <div
                                class="collapsingItem collapsed"
                                id="headingOne"
                                data-toggle="collapse"
                                :data-target="`#collapse-${faq.name.toLowerCase().replaceAll(/ /ig, '')}-${index}`"
                              >
                                <h5 class="mb-0">
                                  <div
                                    class="collapse-items"
                                    style="padding: 0"
                                  >
                                    <i class="faq-images"></i>
                                    <h6>{{ item.question }}</h6>
                                  </div>
                                </h5>
                              </div>

                              <div v-if="item.answer" :id="`collapse-${faq.name.toLowerCase().replaceAll(/ /ig, '')}-${index}`" class="collapse">
                                <p>{{ item.answer }}</p>
                              </div>
                              <div v-if="item.answerHtml" :id="`collapse-${faq.name.toLowerCase().replaceAll(/ /ig, '')}-${index}`" class="collapse" v-html="item.answerHtml">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- Question 1 -->
                      <!-- 
                      <span v-for="qa in faq.qa" :key="qa.question">
                        <h6>{{ qa.question }}</h6>
                        <p>{{ qa.answer }}</p>
                      </span> -->
                      <div class="bottom-divider"></div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <p style="text-align: center;">If you still can't find an answer to your question? Please contact us and get your question quickly resolved.</p>
                </div>
              </div>
            </div>
            <!-- Faq Filter Section End -->
          </div>
          <!-- .entry-content -->
        </article>
        <!-- #post-## -->
      </main>
    </div>
  </div>
</template>

<script>
// /*---------------------------------------------*/
// /*--- 20. ANIMATION DOMAIN NAME ---------------*/
// /*---------------------------------------------*/

export default {
  name: "personal_harassment",
  data() {
    return {
      msg: "Clear Me Out - Personal Cyber Harassments",
      faqList: [],
    };
  },
  mounted() {
    const $this = this;

    jQuery.get("https://staging.clearmeout.com/faq.json").done(function (data) {
      console.log("data", data);
      const _data = Object.values(data);
      $this.faqList = _data;
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* Faq Section CSS */
.faq-filter {
  padding: 80px 0 80px;
}
.faq-filter .filter ul {
  padding: 0;
}
.faq-filter .filter li {
  list-style: none;
}
.faq-filter .filter button {
  outline: none;
}
.faq-filter .filter {
  text-align: center;
  /*box-shadow: 1px 3px 6px rgba(0,0,0,0.16), inset 2px 1px 6px rgba(0,0,0,0.23);*/
}
.faq-filter .filter button {
  border: none;
  background-color: #6773dd;
  width: 100%;
  padding: 12px 0;
  font-size: 16px;
  border-bottom: 1px solid #cac8c885;
  color: #fff;
}
.faq-filter .filter button:hover {
  background-color: #81da9e;
  color: #fff;
  border-bottom: 1px solid #ddd;
}

.faq-filter .filter .faq1 button {
  color: #fff;
}
.faq-filter .filter:hover .faq1 button {
  color: #6773dd;
}
.faq-filter .filter .faq-butn button:hover {
  background-color: #81da9e;
  color: #fff;
  border-bottom: 1px solid #ddd;
}

.faq-filter .card-header button {
  font-size: 18px;
  padding-bottom: 0;
}
.faq-filter .full-faq {
  outline: none;
}
.faq-filter .full-faq h2 {
  color: #63b966;
  margin: 0;
  font-size: 30px;
  letter-spacing: -0.1px;
  margin-bottom: 32px;
}
.faq-filter #Personal,
#Business h2 {
  margin-top: 36px;
}
.faq-filter .full-faq h6 {
  color: #6773dd;
  font-size: 20px;
  font-weight: 400;
  margin: 13px 0 7px;
}
.faq-filter .full-faq p {
  font-size: 15px;
  line-height: 25px;
  font-family: Nunito;
  color: #828282;
  letter-spacing: -0.1px;
  margin-bottom: 25px;
}
.faq-filter .full-faq .bottom-divider {
  border-top: 1px solid #e8e8e8;
  padding-bottom: 40px;
  margin-top: 40px;
}

.faq-title {
  display: inline-block;
  width: 100%;
}

.faq-title .mt_typed-beforetext {
  color: #6f85ff;
  font-size: 46px;
}
.faq-title .parent-typed-text {
  padding-top: 70px;
}
</style>



// WEBPACK FOOTER //
// src/components/faq.vue